<!--
 * @Date: 2021-03-25 13:33:48
 * @LastEditors: natsu
 * @LastEditTime: 2021-03-25 13:36:31
-->
<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2020-06-08 15:29:33
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>Clickstream</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/clickstream/";
export default {
  name: "clickstream",
  data() {
    return {
      fileList: [
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/clickstream-sdk.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListClickstream.vue